import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Desk95 } from '@/components/desk-95/desk-95'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Desk 95'
                description='A Windows 95 desktop holding ten archive documents: drag the files, open the folders, read the sheets.'
                ogImage='/projects/noir-leather.jpg'
            />

            <Desk95 />
        </Layout>
    )
}

export default Home
